<template>
  <div class="gift-card-skeleton">
    <div class="skeleton-image"></div>
    <div class="skeleton-content">
      <div class="skeleton-header">
        <div class="skeleton-title"></div>
        <div class="skeleton-badge"></div>
      </div>
      <div class="skeleton-description"></div>
      <div class="skeleton-footer">
        <div class="skeleton-btn"></div>
        <div class="skeleton-info"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GiftCardSkeleton"
}
</script>

<style scoped>
.gift-card-skeleton {
  display: flex;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: none;
  overflow: hidden;
  margin-bottom: 16px;
}

/* Skeleton animation */
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-image,
.skeleton-title,
.skeleton-badge,
.skeleton-description,
.skeleton-btn,
.skeleton-info {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-image {
  width: 180px;
  min-height: 140px;
  flex-shrink: 0;
  border-radius: 0;
}

.skeleton-content {
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
}

.skeleton-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.skeleton-title {
  height: 20px;
  width: 60%;
  border-radius: 4px;
}

.skeleton-badge {
  height: 24px;
  width: 60px;
  border-radius: 12px;
  display: none;
}

.skeleton-description {
  height: 14px;
  width: 80%;
}

.skeleton-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
}

.skeleton-btn {
  height: 32px;
  width: 90px;
  border-radius: 6px;
}

.skeleton-info {
  height: 14px;
  width: 80px;
}

/* Tablet (1024px) */
@media (max-width: 1024px) {
  .skeleton-image {
    width: 160px;
    min-height: 130px;
  }

  .skeleton-content {
    padding: 14px;
  }
}

/* Small Tablet (768px) */
@media (max-width: 768px) {
  .skeleton-image {
    width: 140px;
    min-height: 120px;
  }

  .skeleton-content {
    padding: 12px;
    gap: 10px;
  }

  .skeleton-title {
    height: 16px;
  }

  .skeleton-btn {
    height: 28px;
    width: 80px;
  }
}

/* Mobile (576px) */
@media (max-width: 576px) {
  .gift-card-skeleton {
    margin-bottom: 10px;
    border-radius: 10px;
  }

  .skeleton-image {
    width: 85px;
    min-height: 90px;
  }

  .skeleton-content {
    padding: 10px;
    gap: 8px;
  }

  .skeleton-header {
    gap: 8px;
  }

  .skeleton-title {
    height: 14px;
    width: 50%;
  }

  .skeleton-badge {
    display: block;
    height: 18px;
    width: 50px;
    border-radius: 10px;
  }

  .skeleton-description {
    display: none;
  }

  .skeleton-footer {
    margin-top: 0;
  }

  .skeleton-btn {
    height: 24px;
    width: 60px;
    border-radius: 14px;
  }

  .skeleton-info {
    height: 12px;
    width: 60px;
  }
}

/* Small Mobile (400px) */
@media (max-width: 400px) {
  .gift-card-skeleton {
    margin-bottom: 8px;
    border-radius: 8px;
  }

  .skeleton-image {
    width: 70px;
    min-height: 80px;
  }

  .skeleton-content {
    padding: 8px;
    gap: 6px;
  }

  .skeleton-title {
    height: 12px;
  }

  .skeleton-badge {
    height: 16px;
    width: 40px;
  }

  .skeleton-btn {
    height: 22px;
    width: 50px;
  }

  .skeleton-info {
    height: 10px;
    width: 50px;
  }
}

@media (max-width: 576px) {
  .gift-card-skeleton {
    min-width: 0;
    min-height: 0;
  }

  .skeleton-image {
    width: 88px;
    min-width: 88px;
  }
}
</style>
